
import React from 'react';
import { Link } from "react-router-dom";
import { Button } from "@/components/Button";
import { ArrowRight, Users } from "lucide-react";

const TeamWorkshopsTab = () => {
  return (
    <div className="mt-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <div className="mb-6">
            <img 
              src="/lovable-uploads/Workshop_graphic.png" 
              alt="Team workshop graphic" 
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
          <h3 className="text-2xl font-bold mb-3 text-white">Empower Your Legal Team with Practical AI Expertise — In Just One Hour</h3>
          <p className="text-lg text-primary mb-5">AI is Changing the Legal Landscape. Is Your Team Ready?</p>
          
          <p className="text-base text-foreground/80 mb-6">
            Our virtual workshops deliver actionable training, customized insights, and strategic frameworks your team can use immediately.
          </p>
        </div>
        
        <div className="flex items-center justify-center">
          <div className="space-y-6 w-full">
            <div className="p-6 rounded-xl border border-white/10 bg-white/5 backdrop-blur-lg shadow-lg">
              <h4 className="text-lg font-semibold mb-3 text-white">What's included:</h4>
              <ul className="list-disc list-inside text-foreground/80 space-y-2 pl-2 mb-6">
                <li>Live, expert-led virtual training session</li>
                <li>Actionable AI strategies tailored for legal teams</li>
                <li>Safe implementation of practical use cases</li>
                <li>Interactive Q&A to apply concepts to your firm's practice</li>
                <li>Follow-up resource pack with key takeaways and tools</li>
              </ul>
              
              <Link to="/services/training/workshops-pricing">
                <Button variant="primary" hasAnimation={true}>
                  Book Your Team Workshop <ArrowRight className="h-4 w-4 ml-1" />
                </Button>
              </Link>
            </div>
            
            <div className="p-6 rounded-xl border border-white/10 bg-white/5 backdrop-blur-lg shadow-lg">
              <h4 className="text-xl font-semibold mb-3">Looking to customize the program?</h4>
              <p className="mb-4 text-foreground/80">
                No problem. Docket Labs offers flexible bundle pricing, workshop agendas, and scheduling to guarantee satisfaction.
              </p>
              
              <Link to="/services/training/workshops-pricing">
                <Button variant="primary" hasAnimation={true}>
                  View Workshop Plans <ArrowRight className="h-4 w-4 ml-1" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-12 p-6 rounded-xl border border-white/10 bg-gradient-to-r from-primary/10 to-background backdrop-blur-lg">
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="p-4 rounded-full bg-primary/20">
            <Users className="h-8 w-8 text-primary" />
          </div>
          <div className="text-center md:text-left">
            <h4 className="text-xl font-semibold mb-2">Workshops Tailored to Your Practice Area</h4>
            <p className="text-foreground/80">
              Our workshops are customized to your specific legal practice area and team size, ensuring maximum relevance and impact.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamWorkshopsTab;
